import { useEffect, useState } from 'react';
import { editionMotionDuration } from './generated/motion';
export default function useEditionMotion(scene, disabled, readyKey) {
  const [frame, setFrame] = useState({ scene, readyKey, progress: 1 });
  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    let raf = 0,
      start;
    const finish = () => {
      cancelAnimationFrame(raf);
      setFrame({ scene, readyKey, progress: 1 });
    };
    const tick = (time) => {
      start ??= time;
      const progress = Math.min(1, (time - start) / editionMotionDuration[scene]);
      setFrame({ scene, readyKey, progress });
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    const visibility = () => {
      if (document.hidden) finish();
    };
    const preference = () => {
      if (media.matches) finish();
    };
    if (disabled || !readyKey || media.matches || document.hidden) finish();
    else raf = requestAnimationFrame(tick);
    document.addEventListener('visibilitychange', visibility);
    media.addEventListener('change', preference);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener('visibilitychange', visibility);
      media.removeEventListener('change', preference);
    };
  }, [scene, disabled, readyKey]);
  return disabled ? 1 : frame.scene === scene && frame.readyKey === readyKey ? frame.progress : 0;
}
